import { dateFormatter } from "@/components/DateFormat/DateFormat";
import Modal from "@/components/Modal/Modal";
import { useAppDispatch } from "@/store/hooks";
import type { RootState } from "@/store/rootReducer";
import { getMyReferralById } from "@/store/slices/ReferralProgramSlice";
import type React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

interface ViewReferralProps {
    viewModalOpen: boolean;
    closeModal: () => void;
}

const ReferralBusinessDetail: React.FC<ViewReferralProps> = ({ viewModalOpen, closeModal, }) => {

    const { modalOpen } = useSelector((state: RootState) => state.global);

    return (
        <>
            <Modal
                modalOpen={viewModalOpen}
                closeModal={closeModal}
                heading="Details"
                width="600px"
                hideFooter={true}
                hideAddButton={true}
                hideCancelButton={true}
            >
                { modalOpen.data && (

                        <div className="p-3 overflow-y-auto">
                            {/* Top Section */}
                            <div className="grid grid-cols-3 gap-6 mb-2">
                                <div>
                                    <p className="font-medium text-lg">Company Name</p>
                                    <p className="text-gray-600">{modalOpen.data.leadName || "-"}</p>
                                </div>

                                <div>
                                    <p className="font-medium text-lg">Transaction value</p>
                                    <p className="text-gray-600">{modalOpen.data.transactionValue || "-"}</p>
                                </div>

                                <div>
                                    <p className="font-medium text-lg">Created Date</p>
                                    <p className="text-gray-600">{dateFormatter(modalOpen.data.createdDate,"dd MMM yyyy") || "-"}</p>
                                </div>

                                <div>
                                    <p className="font-medium text-lg">Created By</p>
                                    <p className="text-gray-600">{modalOpen.data.actionBy || "-"}</p>
                                </div>

                                <div>
                                    <p className="font-medium text-lg">Status</p>
                                    <p className="text-gray-600">
                                        {modalOpen.data.paymentStatus || "-"}
                                    </p>
                                </div>
                                <div>
                                    <p className="font-medium text-lg">Remark</p>
                                    <p className="text-gray-600">{modalOpen.data.remark || "-"}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

            </Modal>
        </>
    )
}

export default ReferralBusinessDetail;
